import { find } from 'lodash/fp';

export const findByValue = (hoseValue) => find(x => x.value === hoseValue);